import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { RecursoCampanhaSituacaoModule } from '../situacao';
import { AreaMultiselectModule } from '../../../areas/components/multiselect';

import { RecursoCampanhaFilterComponent } from './recurso-campanha-filter.component';

@NgModule({
    imports: [
        SharedModule,
        RecursoCampanhaSituacaoModule,
        AreaMultiselectModule
    ],
    declarations: [
        RecursoCampanhaFilterComponent
    ],
    exports: [
        RecursoCampanhaFilterComponent
    ]
})
export class RecursoCampanhaFilterModule { }
